module.exports = __webpack_public_path__ + "static/img/healthcare_loader.be7ff59.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader/healthcare_loader.gif
// module id = qW0w
// module chunks = 7